<template>
  <div v-if="active" class="lightbox">
    <div class="lightbox__underlay" @click="$emit('close')"></div>
    <div class="lightbox__images">
      <tiny-slider
        :mouse-drag="true"
        :loop="false"
        items="1"
        gutter="20"
        :autoplay="false"
        :controls="true"
        controls-container=".lightbox__controls"
        :nav="true"
        nav-container=".lightbox__dots"
      >
        <v-media
          v-for="image in images" 
          :key="image"
          :src="image"
          fit="contain"
        />
      </tiny-slider>
    </div>
    <div class="lightbox__controls">
      <div class="lightbox__controls-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/></svg></div>
      <div class="lightbox__controls-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg></div>
    </div>
    <div class="lightbox__navigation">
      <div class="lightbox__dots">
        <button v-for="index in images.length" :key="index"></button>
      </div>
      <div class="lightbox__disclaimer">NOTE: Images are for general reference only and do not necessarily reflect this particular property.</div>
    </div>
    <div class="lightbox__close" @click="$emit('close')"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></div>
  </div>  
</template>

<script>
import TinySlider from 'vue-tiny-slider'
import VMedia from './VMedia'
export default {
  props: [
    'active',
    'images'
  ],
  components: {
    TinySlider,
    VMedia
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.code === 'Escape' && this.active) {
        this.$emit('close')
      }
    })
  },
  watch: {
    active () {
      document.body.style = this.active ? 'overflow: hidden' : ''
    }
  }
}
</script>

<style lang="scss">
  .lightbox {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    &__controls {
      display: flex;
      justify-content: space-between;
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      outline: 0;
      border: 0;

      [aria-disabled="true"] {
        opacity: 0;
      }

      > div {
        background-color: rgba(#333, 0.8);
        cursor: pointer;
        padding: 10px 10px;
        outline: none;
        border: none;
        transition: opacity 0.3s;
        
        svg {
          fill: white;
          height: 30px;
          width: 30px;
        }        
      }
    }

    &__navigation {
      background-color: rgba(#333, 0.5);
      bottom: 0;
      left: 0;
      padding: 20px 30px;
      position: absolute;
      text-align: center;
      width: 100%;
    }

    &__dots {
      margin-bottom: 10px;

      button {
        cursor: pointer;
        width: 1rem;
        height: 1rem;
        background-color: #fff;
        border-radius: 50%;
        box-shadow: 0 0 5px 0px rgba(#000, 0.2);
        margin: 0 5px;

        &.tns-nav-active {
          background-color: #cbb47f;
        }
      }
    }

    &__disclaimer {
      font-size: 12px;
      text-shadow: 0 0 3px rgba(#000, 0.5);
    }

    &__close {
      background-color: rgba(#333, 0.8);
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      
      svg {
        height: 50px;
        width: 50px;
      }
    }

    &__underlay {
      background: rgba(0, 0, 0, .8);
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }

    &__images {
      width: 100%;

      img {
        max-height: 100vh;
      }
    }
  }

  .tns-item {
    vertical-align: middle !important;
  }
</style>